// import components
import { styled, Box } from '@mui/material';

// import types
import { StyledMultiStepFormProps } from './MultiStepForm.types';

export const StyledMultiStepForm = styled('form', {
  shouldForwardProp: (prop) => prop !== 'fullHeight'
})<StyledMultiStepFormProps>(({ theme, fullHeight }) => ({
  height: fullHeight ? '100%' : 'auto',
  display: 'flex',
  padding: theme.spacing(0, 5),
  flexDirection: 'column'
}));

export const StyledSection = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(4),
  paddingBottom: theme.spacing(6),
  marginBottom: theme.spacing(6),
  borderBottom: `1px solid ${theme.palette.divider}`,

  '&:first-of-type': {
    paddingTop: theme.spacing(6)
  },
  '&:last-of-type': {
    border: 'none'
  }
}));

export const StyledFormSectionMainBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: theme.spacing(75),
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2)
}));

export const StyledShowPreviewBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  marginLeft: theme.spacing(5),
  marginTop: theme.spacing(2)
}));

interface StyledProps {
  fullWidth?: boolean;
}

export const StyledShowPreviewLeftBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'fullWidth'
})<StyledProps>(({ theme, fullWidth }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  maxWidth: fullWidth ? '100vw' : '300px'
}));
